import { render, staticRenderFns } from "./PendingShipOrder.vue?vue&type=template&id=80a5be34&scoped=true&"
import script from "./PendingShipOrder.vue?vue&type=script&lang=js&"
export * from "./PendingShipOrder.vue?vue&type=script&lang=js&"
import style0 from "./PendingShipOrder.vue?vue&type=style&index=0&id=80a5be34&scoped=true&lang=css&"
import style1 from "./PendingShipOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a5be34",
  null
  
)

component.options.__file = "PendingShipOrder.vue"
export default component.exports